"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMap = exports.MapObject = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
const Marker_1 = require("./ObjectsInMap/Marker");
const Geometry_1 = require("./ObjectsInMap/Geometry");
const GeometryMarker_1 = require("./ObjectsInMap/GeometryMarker");
const MarkerLayer_1 = require("./ObjectsInMap/MarkerLayer");
const ClusterMarkerLayer_1 = require("./ObjectsInMap/ClusterMarkerLayer");
const MapObjectProps_1 = require("./MapObjectProps");
class MapObject {
    constructor(props) {
        this.callbacks = [];
        this.notAddedCallbacks = [];
        this.initialized = false;
        this.map = undefined;
        this.createMarker = (location, marker, options) => {
            this.checkIfInitialized();
            const loc = this.transform(location);
            const m = new Marker_1.Marker(loc[0], loc[1], marker, this.map, undefined, options);
            return m;
        };
        this.createGeometry = (points, type, options) => {
            this.checkIfInitialized();
            const m = new Geometry_1.Geometry(points.map((p) => {
                return p.map((p) => {
                    const loc = this.transform(p);
                    return [loc[0], loc[1]];
                });
            }), type, this.map, undefined, options);
            return m;
        };
        this.createGeometryMarker = (points, type, marker, options) => {
            this.checkIfInitialized();
            const m = new GeometryMarker_1.GeometryMarker(points.map((p) => {
                return p.map((p) => {
                    const loc = this.transform(p);
                    return [loc[0], loc[1]];
                });
            }), type, marker, this.map, undefined, options);
            return m;
        };
        this.createLayer = (options) => {
            this.checkIfInitialized();
            const l = new MarkerLayer_1.MarkerLayer(this.map, options);
            return l;
        };
        this.createClusterLayer = (element, options) => {
            this.checkIfInitialized();
            const l = new ClusterMarkerLayer_1.ClusterMarkerLayer(element, this.map, options);
            return l;
        };
        this.projection = props.projection.crs;
        this.transform = props.projection.transform;
        // @ts-ignore
        if (!this.projection.options) {
            this.maxZoom = 18;
        }
        else {
            // @ts-ignore
            this.maxZoom = this.projection.options.resolutions.length - 2;
        }
        this.props = props;
    }
    addListener(event) {
        if (!this.map) {
            this.notAddedCallbacks.push(event);
            return;
        }
        else {
            this.callbacks.push(event);
        }
        this.map.on("zoomend", () => {
            this.callbacks.forEach((element) => {
                element.onZoomChange?.(this.map.getZoom());
            });
        });
    }
    removeListener(event) {
        this.callbacks = this.callbacks.filter((e) => e !== event);
    }
    initialize(htmlElement, callbacks) {
        try {
            const newMap = leaflet_1.default.map(htmlElement, {
                zoomControl: false,
                crs: this.projection,
                maxZoom: this.maxZoom,
                attributionControl: false
            });
            newMap.setView(this.props.startLocation, this.maxZoom / 2);
            leaflet_1.default.tileLayer
                .wms("https://geoportal.cuzk.cz/WMS_ORTOFOTO_PUB/WMService.aspx", {
                layers: "GR_ORTFOTORGB",
                maxZoom: this.maxZoom,
                styles: "",
                format: "image/png",
                transparent: true,
                version: "1.3.0",
                attribution: "ČÚZK"
            })
                .addTo(newMap);
            this.map = newMap;
        }
        catch (e) {
            console.error(e);
        }
        this.initialized = true;
        this.initializeCallbacks(callbacks);
    }
    initializeCallbacks(callbacks) {
        this.addListener(callbacks);
        this.notAddedCallbacks.forEach((e) => {
            this.addListener(e);
        });
        this.notAddedCallbacks = [];
        this.callbacks.forEach((element) => {
            element.onLoad?.(this);
        });
    }
    checkIfInitialized() {
        if (!this.initialized) {
            throw new Error("Map is not initialized yet. Try to use useMap.");
        }
    }
    addTileLayer(layer) {
        this.checkIfInitialized();
        layer.addTo(this.map);
    }
    removeTileLayer(layer) {
        this.checkIfInitialized();
        layer.remove();
    }
    setTileLayer(layer) {
        this.checkIfInitialized();
        this.map.eachLayer((layer) => {
            if (layer instanceof leaflet_1.default.TileLayer) {
                layer.remove();
            }
        });
        layer.addTo(this.map);
    }
}
exports.MapObject = MapObject;
function createMap(props) {
    const propsWithDefaults = {
        ...MapObjectProps_1.defaultMapObjectProps,
        ...props
    };
    return new MapObject(propsWithDefaults);
}
exports.createMap = createMap;
